import type { SWSettings } from "app/common/services/swSettings";
import { swSettings } from "app/common/services/swSettings";
import { i18nFilter, translate } from "app/filters/i18nFilter";
import type { ComponentType } from "react";
import React from "react";
import { connect } from "react-redux";
import type { ISegmentsData } from "app/services/conversion/ConversionSegmentsService";
import { allTrackers } from "app/services/track/track";
import type { ICategoryOverviewProps } from "pro-features/pages/conversion/CategoryOverview";
import { CategoryOverview } from "pro-features/pages/conversion/CategoryOverview";
import { AssetsService } from "app/services/AssetsService";
import ConversionApiService from "../../services/conversion/conversionApiService";
import CategoryConversionTableContainer from "./conversionTableContainer/CategoryConversionTableContainer";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { getTableSelectedItems } from "app/reducers/_reducers/tableSelection.reducer";

interface ICategoryOverviewContainerProps {
    segments: ISegmentsData;
    selectedRows: any;
}

interface ICategoryOverviewContainerState {
    loading: boolean;
    graphData: any;
    scatterData: any;
    tableData: any;
}

const hasPermissions = (permissions, permission) => {
    return permissions[permission];
};

class CategoryOverviewContainer extends React.Component<
    ICategoryOverviewContainerProps,
    ICategoryOverviewContainerState
> {
    public swNavigator: any;
    public swSettings: SWSettings;
    public isCompare: boolean;
    public data: any;
    private readonly conversionApiService: any;
    private pageProps: ICategoryOverviewProps;

    constructor(props) {
        super(props);
        this.swSettings = swSettings;
        this.conversionApiService = new ConversionApiService();
        this.swNavigator = proNavigator;
        this.state = {
            loading: true,
            graphData: null,
            tableData: null,
            scatterData: null,
        };
    }

    public componentDidUpdate() {
        this.pageProps = { ...this.pageProps, segmentsData: this.props.segments };
    }

    public async componentDidMount() {
        const { country, webSource = "Desktop", gid, from, to } = this.swNavigator.getApiParams();
        let response;
        try {
            response = await Promise.all([
                this.conversionApiService.getCategoryConversionGraph({
                    country,
                    webSource,
                    from,
                    to,
                    gid,
                }),
                this.conversionApiService.getCategoryConversionScatterChart({
                    country,
                    from,
                    to,
                    webSource,
                    gid,
                }),
                this.conversionApiService.getCategoryConversionTable({
                    country,
                    from,
                    to,
                    webSource,
                    gid,
                }),
            ]);
        } catch (e) {}

        this.setState({
            graphData: response && response[0] && response[0].Data ? response[0] : {},
            scatterData: response && response[1] && response[1].Data ? response[1] : {},
            tableData: response && response[2] && response[2].Data ? response[2] : {},
            loading: false,
        });
    }

    public homeRedirect = () => {
        this.swNavigator.go("/");
    };

    public render() {
        const pageFilters = this.swNavigator.getApiParams();
        const { gid, country, from, to, webSource = "Desktop" } = pageFilters;
        this.pageProps = {
            loading: this.state.loading,
            translate: i18nFilter(),
            track: allTrackers.trackEvent.bind(allTrackers),
            components: { CategoryConversionTableContainer },
            pageFilters,
            segmentsData: this.props.segments,
            selectedRows: this.props.selectedRows,
            graphData: this.state.graphData,
            onGraphDDClick: (obj) => console.log("downloading graph " + obj.id),
            onScatterDDClick: (obj) => console.log("downloading scatter " + obj.id),
            tableExcelLink: this.conversionApiService.getCategoryConversionExcel({
                gid,
                country,
                from,
                to,
                webSource,
            }),
            scatterData: this.state.scatterData,
            tableData: this.state.tableData,
            getLink: this.swNavigator.href.bind(this.swNavigator),
            getAssetsUrl: AssetsService.assetUrl.bind(AssetsService),
        };

        const permissions = {
            HOOK: this.homeRedirect, // Should be a modal
            HIDDEN: this.homeRedirect,
            OPEN: () => <CategoryOverview {...this.pageProps} />,
        };

        return hasPermissions(
            permissions,
            this.swSettings.current.resources.AvaliabilityMode?.toUpperCase() || "OPEN",
        )();
    }
}

function mapStateToProps(state) {
    const {
        conversionModule: { segments },
    } = state;
    return {
        selectedRows: getTableSelectedItems("CategoryConversionTable")(state),
        segments,
    };
}

export default connect(mapStateToProps, null)(CategoryOverviewContainer as ComponentType<any>);
